import { useNavigate } from 'react-router-dom';

import { ModalChangeApiUrl } from '@/_components/modal-change-system-api-url';
import BrandLogo from '@/Assets/Img/quero-log-logo.svg';
import { isProd } from '@/_config/env';

import styles from './styles.module.scss';

export function QueroLogLogo() {
  const navigate = useNavigate();

  return (
    <ModalChangeApiUrl>
      <div className={styles.logo} onClick={() => isProd && navigate('/')}>
        <img className={styles.imgLogo} src={BrandLogo} alt="quero log" />
      </div>
    </ModalChangeApiUrl>
  );
}
